module.exports = __webpack_public_path__ + "media/images/social/social-icon-vk-5d5729436275d73aed93f732a812823a.svg";